// Stub that replaces react-player's heavy streaming players (hls/dash/mux) via a
// Vite alias, so their SDKs (hls.js, dashjs, @mux) are never bundled. These
// formats are not used; such a source would render nothing rather than crash.
const EmptyPlayer = () => null;

export default EmptyPlayer;
